<script>
/**
 * @ 使用方法
  <g-img
    class="close-img"
    :src="require('@/assets/images/close.png')"
    :size="40"
    @click="changeShow"
  ></g-img>
 * @param
 * src 图片路径
 * size 图片宽高 默认为60
 * normal 图片是否是原始图片
 * color 图片颜色 默认是主题色
*/
</script>

<template>
  <div @click="imgHandler">
    <div v-if="this.normal">
      <img
        :src="myImg"
        :style="{ width: this.size / 2 + 'px', height: this.height || 'unset' }"
        srcset=""
      />
    </div>
    <div
      v-else
      :class="this.size ? '' : 'box'"
      ref="boxRef"
      :style="this.size ? obj : {}"
    >
      <img
        :src="myImg"
        :class="this.size ? '' : 'inner-img'"
        ref="imgRef"
        :style="this.size ? obj2 : {}"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GImg",
  props: {
    src: {
      type: [String, Object],
      default: "",
      required: true,
    },
    size: {
      type: [Number, String],
      default: 60,
    },
    height: {
      type: String,
      default: "",
    },
    color: {
      type: [String, Object],
      default: () => {
        const themeColor = getComputedStyle(document.body).getPropertyValue(
          "--tc"
        );
        return themeColor;
      },
    },
    normal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    src(val) {
      if (val) {
        this.myImg = this.handleImg(val);
      }
    },
  },
  computed: {
    phoneType() {
      return sessionStorage.getItem("phoneSystem");
    },
  },
  data() {
    return {
      myImg: this.handleImg(this.src),
      obj: {
        overflow: "hidden",
        width: `${this.size / 2}px`,
      },
      obj2: {
        width: `${this.size / 2}px`,
        display: "block",
        // position: "relative",
        // left: `-${this.size / 2}px`,
        // willChange: "transform",
        willChange: "unset",
        borderRight: "20px solid transparent",
        filter: `drop-shadow(${this.size / 2}px 0 ${this.color})`,
        transform: `translateX(-${this.size / 2}px)`,
        // '-webkit-filter': `drop-shadow(${this.size / 2}px 0 ${this.$store.state.tc})`,
      },
    };
  },
  created() {
    // console.log(this.$store.state.browserType);
    this.obj2.willChange = this.phoneType == "ios" ? "transform" : "unset";
  },
  mounted() {},
  methods: {
    handleImg(src) {
      let hasPrefix = /\.[a-zA-Z]+$/.test(src);
      let prefix = "";
      if (!hasPrefix) {
        prefix = ".png";
      }
      let isBase64 = /^data\:image/.test(src);
      if (isBase64) {
        return src;
      } else if (src.indexOf("/") === -1 && src.indexOf("http") === -1) {
        // return "require('@/assets/images/" + src + prefix + "')";
        let res = src + prefix;
        return require("@/assets/images/" + res);
        // return require('' + cc + '')
        // return require('' +res);
      } else {
        return src + prefix;
      }
    },
    init() {
      this.$nextTick(() => {});
    },
    imgHandler() {
      this.$emit("click");
    },
  },
};
</script>
<style scoped lang="scss">
/* .box {
  width: 60px;
  overflow: hidden;
}
.box .inner-img {
  width: 60px;
  display: block;
  position: relative;
  left: -60px;
  border-right: 2px solid transparent;
  filter: drop-shadow(60px 0 red);
  -webkit-filter: drop-shadow(60px 0 red);
} */
</style>
